"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applicationErrorFactory;
exports.ApplicationError = void 0;

/**
 * @module web-panel-essentials/errors
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Wednesday, 14th August 2019 4:21:03 pm
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 */

/**
 * ApplicationError class
 * @class ApplicationError
 */
class ApplicationError extends Error {
  constructor({
    code,
    message,
    args
  }) {
    super(message);
    this.name = 'ApplicationError';
    this.code = code;
    this.message = message || '';
    this.args = args || [];
    this.stack = new Error().stack;
  }

}
/**
 * Returns new instance on application error based on incoming message and code params
 * @function applicationErrorFactory
 * @param {*} code
 * @param {*} message
 * @param {*} args
 */


exports.ApplicationError = ApplicationError;

function applicationErrorFactory(code, message, ...args) {
  return new ApplicationError({
    code,
    message,
    args
  });
}